import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {PageSaveButton,TableCheckBox,CustomTableRow,AddNewButtonLayout,
    DialogSaveButton} from '../../../common/Global/globalStyles.style';
import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,
    removeHtmlTags,isEmptyArray,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import RegularDropdown from '../../../common/DropdownMenus/RegularDropdown';
import {Accordion, Button, Card} from 'react-bootstrap';
import FilterDropDown from "../../../common/DropdownMenus/FilterDropdown";
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();

const activeStatus="Active";
const resourceDropdownPlaceholder="Select Resource";

class AddTaskAndResource extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            apiSearchKey:"",
            searchkey:"",
            currentPageNo: 1,
            showLoader:false,
            resultSize:Constants.RESULT_SIZE,
            totalCount:0,
            datalist:[],
            resultSizePlaceholder:Constants.RESULT_SIZE,
            status:activeStatus,

            users:[],
            processMap:[],
            processId:this.props.processId,

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            // addErrors:{},
            resourceDropdownPlaceholder:"Select Resource",

            filterDataList: [],
            FilterDropDownArr: [],
            FilterPlaceholder: "All",
            activeKey: null
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getInitData();
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props)){
            this.setState({
                componentDidMountFlag:false,
                apiSearchKey:"",
                searchkey:"",
                currentPageNo: 1,
                showLoader:false,
                resultSize:Constants.RESULT_SIZE,
                totalCount:0,
                datalist:[],
                resultSizePlaceholder:Constants.RESULT_SIZE,
                status:activeStatus,

                users:[],
                processMap:[],
                processId:this.props.processId,

                showAlertDialogInfo:false,
                alertDialogMessageInfo:"",

                // addErrors:{},
                showProcessFunctionsDialog:false,
                resourceDropdownPlaceholder:"Select Resource",
            },()=>{
                this.getInitData();
            })
            
        }
    }

    resourceDropdownClick = (resource) => {

        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            let newTaskList = value.taskList.map(item=>{
                if(item.isSelected){
                    item.addedResourceToAssignment = true;
                    item.resourceName = resource.userName;
                    item.resourceId = resource.userId;
                    item.resourceDesignation = resource.designation;
                    item.resourcefullName = resource.fullName;
                }
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onCancelClick = () => {
        this.props.onClickBackBtnFromAddTasks();
    }

    //No need of return value since the array itself is passed and updated.
    addParentIdandHasChildrenFlag = (tempArr, checkListHeadingId, parentCheckListHeadingId, parentHeadingBreadCrumb) => {
        tempArr[checkListHeadingId].parentCheckListHeadingId = parentCheckListHeadingId;
        let breadCrumb = "";

        if(isEmptyVariable(parentHeadingBreadCrumb)){
            breadCrumb = tempArr[checkListHeadingId].heading;
            tempArr[checkListHeadingId].breadCrumb = breadCrumb;
        }else{
            breadCrumb = parentHeadingBreadCrumb + " > " + tempArr[checkListHeadingId].heading;
            tempArr[checkListHeadingId].breadCrumb = breadCrumb;
        }

        if(!isEmptyArray(tempArr[checkListHeadingId].children)){
            tempArr[checkListHeadingId].hasChildren = true;

            tempArr[checkListHeadingId].children.map(childNode => {
                this.addParentIdandHasChildrenFlag(tempArr,childNode.headingId,checkListHeadingId,breadCrumb);
            });
        }else{
            tempArr[checkListHeadingId].hasChildren = false;
        }
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    handleSelectionTasks = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let indexAndProcessId = e.target.name;
        let iapArr = indexAndProcessId.split(":-:")
        let index = iapArr[0];
        let headingId = iapArr[1];
        let list = this.state.datalist;

        list[headingId].taskList[index].isSelected = isChecked;

        //check whether all the tasks with in func are selected
        let atleastOneNotSelected = list[headingId].taskList.some(item => !item.isSelected)
        list[headingId].isHeadingSelected = !atleastOneNotSelected;

        this.setState({
            datalist:list
        });
    }

    handleSelectionHeadingTasks = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let headingId = e.target.name;
        let list = this.state.datalist;

        list[headingId].isHeadingSelected = isChecked;

        // also select all the tasks
        let newTasklist = list[headingId].taskList.map(item=>{
            item.isSelected = isChecked
            return item;
        })
        list[headingId].taskList = newTasklist;
        this.setState({
            datalist:list
        });
    }

    selectAll = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isHeadingSelected = true;
            let newTaskList = value.taskList.map(item=>{
                item.isSelected = true;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    unSelectAll = () => {
        let newDataList = {};
        for (const [key, value] of Object.entries(this.state.datalist)) {
            let newValue = value;
            newValue.isHeadingSelected = false;
            let newTaskList = value.taskList.map(item=>{
                item.isSelected = false;
                return item;
            })
            newValue.taskList = newTaskList;
            newDataList[key] = newValue;
        }
        this.setState({
            datalist:newDataList
        })
    }

    getRootLevelFunctions = (functionMapTemp) => {
        let rootFunctionArr = [];
        Object.values(functionMapTemp).map((item)=>{
            if(item.level === 0){
                rootFunctionArr.push(item);
            }
        })
        return rootFunctionArr;
    }

    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });

        let postParams = {
            email:userDetails.email,
            accessToken:userDetails.accessToken,
            assignmentId:this.props.assignmentId,
        }
        if(!this.props.checklistIdAlreadySaved){
            postParams.checkListVersionId = this.props.checkListVersionId;
        }

        Promise.all([
            fetch(Constants.GetChecklistHeadings,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    checkListVersionId:this.props.checkListVersionId,
                })
            }),
            fetch(Constants.GetAssignTaskMasterData,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams(postParams)
            }),
            fetch(Constants.GetAssignedTasks,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                })
            })
        ])
        .then(([masterRes,generalRes,assignedTasksRes]) => { 
            return Promise.all([masterRes.json(),generalRes.json(),assignedTasksRes.json()]) 
        })
        .then(([masterRes,generalRes,assignedTasksRes]) => {
            let processMapTemp = {};
            let datalistTemp = {};
            let users = [];
            let assignedTasksMap = {};
            let headingMap = {};

            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if(masterRes.responseCode === Constants.CODE_SUCCESS){
                headingMap = masterRes.result.headingMap;
                
                let rootLevelArr = this.getRootLevelFunctions(headingMap)
                for(const [index,value] of rootLevelArr.entries()){
                    this.addParentIdandHasChildrenFlag(headingMap,value.checkListHeadingId,value.checkListHeadingId,"");
                }
            }else{
            }


            if(handleTokenExpiry(assignedTasksRes.responseCode)) return;
            else if(assignedTasksRes.responseCode === Constants.CODE_SUCCESS){
                let assignedTasks = assignedTasksRes.data.assignedTasks;

                //so that you can access the details of any tasks by its taskId
                assignedTasks.forEach(item=>{
                    assignedTasksMap[item.taskId] = item;
                })
            }else{
            }
            if(handleTokenExpiry(generalRes.responseCode)) return;
            else if(generalRes.responseCode === Constants.CODE_SUCCESS){
                let assignmentReviewMatrix = generalRes.data.assignmentReviewMatrix;
                let assignmentMemberMatrix = generalRes.data.assignmentMemberMatrix;

                //need to get only active users
                let activeMembers = assignmentMemberMatrix.filter(item=> item.status === "Active");
                let activeReviewers = assignmentReviewMatrix.filter(item=> item.status === "Active");

                users = [...activeMembers,...activeReviewers]

                let datalistTempArr = generalRes.data.taskList;//list of process and task
                datalistTemp = {};

                datalistTempArr.map((item)=>{

                    //Now lets add the already assigned tasks
                    let updatedTaskList = [];
                    item.taskList.forEach(task=>{
                        //check if the taskId is there in task map, if yes then add the 
                        //user info
                        task.added = true;
                        
                        if(!isEmptyVariable(assignedTasksMap[task.taskId])){
                            task.assigmentTaskStatus = assignedTasksMap[task.taskId].status;
                            task.assignmentTaskId = assignedTasksMap[task.taskId].assignmentTaskId;
                            task.completionStatus = assignedTasksMap[task.taskId].completionStatus;
                            task.resourceName = assignedTasksMap[task.taskId].userName;
                            task.resourceId = assignedTasksMap[task.taskId].userId;
                            task.resourceDesignation = assignedTasksMap[task.taskId].designation;
                            task.resourcefullName = assignedTasksMap[task.taskId].userName+"("+assignedTasksMap[task.taskId].designation+")";
                        }

                        updatedTaskList.push(task);
                    })
                    item.taskList = updatedTaskList;
                    
                    //for accessing the process details by its processId
                    datalistTemp[item.checkListHeadingId] = item;
                    datalistTemp[item.checkListHeadingId].currentPageNo = 1; //set the current page no as 1 for all the individual task lists
                })
            }else{
            }
            
            let tempFilterArray = [
                {
                  label: "All",
                  isSelected: true,
                },
              ];
              Object.values(datalistTemp).map((processObj)=>{
                tempFilterArray.push({
                    label:headingMap[processObj.checkListHeadingId].heading,
                    isSelected:false
                })
              })

            this.setState({
                componentDidMountFlag:true,
                showLoader:false,

                processMap:headingMap,
                datalist:datalistTemp,
                users:users,

                FilterDropDownArr:tempFilterArray,
            })
        })
    }

    onClickAddResourceToAssignment = () => {
        let isError = false;
        // let addTaskAndResourceErr = "";
        Object.values(this.state.datalist).forEach(processObj=>{
            processObj.taskList.forEach(item=>{
                if(item.added && isEmptyVariable(item.resourceId)){
                    isError = true;
                    // addTaskAndResourceErr = "Please add resource to all the tasks";
                }else{
                    
                }
            })
        })

        if(isError){
            this.setState({
                showAlertDialogInfo:true,
            	alertDialogMessageInfo:"Please add resource to all the tasks"
            })
        }else{
            //now parse the array
            let assignmentTasks = []
            Object.values(this.state.datalist).forEach(processObj=>{
                processObj.taskList.forEach(item=>{
                    if(item.added && !isEmptyVariable(item.resourceId)){
                        let obj = {
                            taskId:item.taskId,
                            userId:item.resourceId,
                            userName:item.resourceName,
                            designation:item.resourceDesignation,
                        }


                        if(!isEmptyVariable(item.assignmentTaskId)){
                            obj.assignmentTaskId = item.assignmentTaskId;
                        }
                        
                        assignmentTasks.push(obj);
                    }
                })
            })


            //call the fetch function
            fetch(Constants.AssignTasks,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentTasks:JSON.stringify(assignmentTasks),
                    assignmentId:this.props.assignmentId
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.props.onClickBackBtnFromAddTasks(true);
                }else{
                    this.setState({
                        showAlertDialogInfo:true,
            	        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });

        }
    }
    /*******************API CALLS END HERE*******************/

    filterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.FilterDropDownArr;
        if(selectedItem.label==="All")
        {
            this.setState({
                filterDataList:[],
            })
        }
        else{

            Object.values(this.state.datalist).map((item)=>{
                if(selectedItem.label === item.heading)
                {
                    tempFilterDataList.push(
                        item
                    )
                }
            })

        }
        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
            item.isSelected = true;
            } else {
            item.isSelected = false;
            }
          });

        this.setState({
            filterDataList:tempFilterDataList,
            FilterDropDownArr:tempFilterDataArray,
            FilterPlaceholder:selectedItem.label

        })
    }

    handleAccordionToggle = (eventKey) => {
        if (this.state.activeKey === eventKey) {
            this.setState({ activeKey: null });
        } else {
            this.setState({ activeKey: eventKey });
        }
    }

    render() {
        return(
            <div>
                {
                    this.state.showLoader &&
                    <div class="loader"></div>
                }
                {
                    // Need to check component did mount flag, other wise until api is called,
                    // it shows no items found layout.
                    this.state.componentDidMountFlag &&
                    <div className="body-wrapper">
                        <div className="secondary-bar-wrapper">
                            <div className="flex-center-layout secondary-top-bar m-t-0">
                                <div className="back-btn-layout" onClick={this.props.onClickBackBtnFromAddTasks}>
                                    <span class="material-icons-outlined">arrow_back_ios</span>
                                </div>
                                <h6>{this.props.referenceNo}</h6>
                            </div>
                            <div className="flex-center-layout">
                                <div style={{ marginRight: 10 }}>
                                    <FilterDropDown
                                        placeholder={this.state.FilterPlaceholder}
                                        dropdownArr={this.state.FilterDropDownArr}
                                        onDropDownItemClick={this.filterDropDownOnClick}
                                        themeSettings={themeSettings}
                                        name={"label"}
                                        dropdownWidth="200px"
                                    />
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.unSelectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box_outline_blank
                                        </span>
                                        <p>Unselect All</p>
                                    </a>
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.selectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box
                                        </span>
                                        <p>Select All</p>
                                    </a>
                                </div>

                                <div style={{width:"300px"}}>
                                    <RegularDropdown 
                                        placeholder={this.state.resourceDropdownPlaceholder}
                                        dropdownArr={this.state.users}
                                        labelParam="fullName"
                                        onDropDownItemClick={this.resourceDropdownClick}
                                        defaultPlaceholderDropDown={resourceDropdownPlaceholder}
                                    />
                                </div>

                                <DialogSaveButton  themeSettings={themeSettings} 
                                style={{marginLeft:5}}
                                onClick={this.onClickAddResourceToAssignment} type="button" 
                                className="modal-save m-b-0">Assign</DialogSaveButton>
                                
                            </div>
                        </div>
                        <div className="assign-tasks-layout accordion-layout">
                            {
                                Object.values( isEmptyArray(this.state.filterDataList)?this.state.datalist:this.state.filterDataList).map((processObj,index)=>{
                                    let className;
                                    if (index === 0) {
                                        className = 'card-radius'; // CSS for the first item
                                    } else if (index === (Object.values(isEmptyArray(this.state.filterDataList)?
                                    this.state.datalist:this.state.filterDataList).length - 1)) {
                                        className = 'card-last'; // CSS for the last item
                                    } else {
                                        className = 'card-middle'; // CSS for all other items
                                    }
                                    return <div className="process-task-list">
                                        <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeKey}>
                                            <Card className={className}> 
                                                <Card.Header>
                                                    <Accordion.Toggle
                                                        as={Button}
                                                        variant="link"
                                                        eventKey={processObj.checkListHeadingId}
                                                        onClick={() => this.handleAccordionToggle(processObj.checkListHeadingId)}
                                                    >
                                                        <div className='row align-items-center'>
                                                            <TableCheckBox onClick={this.handleStopPropagation}
                                                                themeSettings={themeSettings}>
                                                                <input 
                                                                    type="checkbox"
                                                                    name={processObj.checkListHeadingId}
                                                                    id={processObj.checkListHeadingId}
                                                                    onChange={this.handleSelectionHeadingTasks}
                                                                    checked={processObj.isHeadingSelected?true:false}
                                                                />
                                                                <label for={processObj.checkListHeadingId} 
                                                                style={{marginLeft:-3}}></label>
                                                            </TableCheckBox>
                                                                <h6 className='col-md-8 text-left'>{this.state.processMap[processObj.checkListHeadingId].breadCrumb}</h6>
                                                                <h6 className='col-md-3 text-center'>{"Added to Assignment: "+processObj.taskList.filter(item => item.added == true).length}</h6>
                                                        </div>
                                                    </Accordion.Toggle>
                                                </Card.Header> 
                                                <Accordion.Collapse eventKey={processObj.checkListHeadingId}>
                                                    <Card.Body>
                                                        {
                                                            isEmptyArray(processObj.taskList) &&
                                                            <div class="no-items-layout">
                                                                <div class="no-items-card" style={{padding:"10px"}}>
                                                                    <h6 style={{margin:0}}>
                                                                    {
                                                                        isEmptyVariable(this.state.apiSearchKey)?
                                                                        Constants.NO_RECORDS_WARNING
                                                                        :
                                                                        Constants.EMPTY_SEARCH_WARNING
                                                                    }
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        }
                                                        {
                                                            !isEmptyArray(processObj.taskList) &&
                                                            <div className="common-tab-bg">
                                                                <div class="common-table" style={{width: "100%", borderRadius: "4px"}}>
                                                                    <div className="table-custom-layout">
                                                                        <div className="table-custom-header">
                                                                            <div className="table-custom-header-row">
                                                                                <p style={{width:"5%"}}></p>
                                                                                <p style={{width:"5%",justifyContent:"center"}}>No</p>
                                                                                <p style={{width:"52%"}}>Task</p>
                                                                                <p style={{width:"30%"}}>Resource</p>
                                                                                <p style={{width:"8%"}}>Added</p>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div className="table-custom-body">
                                                                        {
                                                                            !isEmptyArray(processObj.taskList) && 
                                                                            processObj.taskList.map((item,idx) => {
                                                                                return <CustomTableRow themeSettings={themeSettings}
                                                                                className={item.disabled?"row-disable":""}>
                                                                                    <div className="table-cell" style={{width:"5%"}}>
                                                                                        <TableCheckBox onClick={this.handleStopPropagation}
                                                                                            themeSettings={themeSettings}>
                                                                                            <input 
                                                                                                type="checkbox"
                                                                                                name={idx+":-:"+processObj.checkListHeadingId}
                                                                                                id={idx+":-:"+item.taskId}
                                                                                                onChange={this.handleSelectionTasks}
                                                                                                disabled={item.disabled}
                                                                                                checked={item.isSelected?true:false}
                                                                                            />
                                                                                            <label for={idx+":-:"+item.taskId} 
                                                                                            style={{marginLeft:6}}></label>
                                                                                        </TableCheckBox>
                                                                                    </div>
                                                                                    <p style={{width:"5%",justifyContent:"center"}}>{(idx+1)}</p>
                                                                                    <p style={{width:"52%"}}>
                                                                                        {removeHtmlTags(item.task)}
                                                                                        {
                                                                                            item.completionStatus==="Completed" &&
                                                                                            <span style={{marginLeft:6,fontSize:18}}
                                                                                            className="material-icons">done_all</span>
                                                                                        }
                                                                                    </p>
                                                                                    <p style={{width:"30%"}}>{isEmptyVariable(item.resourcefullName)?"":item.resourcefullName}</p>
                                                                                    <p style={{width:"8%"}}>
                                                                                        {
                                                                                            item.added &&
                                                                                            <span class="material-icons"
                                                                                            style={{color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`}}>check_circle</span>
                                                                                        }
                                                                                    </p>
                                                                                    
                                                                                </CustomTableRow>
                                                                            })
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    </div>
                                })
                            }
                            {/* {
                                !isEmptyVariable(this.state.addTaskAndResourceErr) &&
                                <span class="cm-error">{this.state.addTaskAndResourceErr}</span>
                            } */}
                            {/* <div className="row custom-row">
                                <div className="col-md-12 custom-col">
                                    <div className="modal-close-save" style={{marginBottom:20}}>
                                        <div className="close-save-col">
                                            <button onClick={this.props.onClickBackBtnFromAddTasks} type="button" 
                                            className="modal-close m-b-0">Cancel</button>
                                            <DialogSaveButton  themeSettings={themeSettings} 
                                            onClick={this.onClickAddResourceToAssignment} type="button" 
                                            className="modal-save m-b-0">Assign</DialogSaveButton>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    
                }

                {/* Add Resources Dialog */}
                <AlertDialog
					showAlertDialog={this.state.showAlertDialogInfo}
					handleAlertDialogClose={this.handleAlertDialogCloseInfo}
					type={Constants.ALERT_TYPE_ALERT}
					alertDialogMessage={this.state.alertDialogMessageInfo}
					proceedBtnClick={this.handleAlertDialogCloseInfo}
					proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
					themeSettings={themeSettings}
				/>
            </div>
        );
    }
}

export default AddTaskAndResource;